module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [(_vm.brandName && _vm.storeName) ? _c('h1', {
    staticStyle: {
      "position": "absolute",
      "top": "-39px",
      "left": "142px",
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.brandName) + " - " + _vm._s(_vm.storeName))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body form"
  }, [_c('div', {
    staticClass: "flex justify-between"
  }, [_c('div', {
    staticClass: "flex m-b-10"
  }, [_c('label', {
    class: ['btn btn-left', _vm.switchType === 'choose' ? 'btn-primary' : 'btn-default'],
    attrs: {
      "for": "choose"
    }
  }, [_vm._v("搜尋商品")]), _vm._v(" "), _c('label', {
    class: ['btn btn-right', _vm.switchType === 'input' ? 'btn-primary' : 'btn-default'],
    attrs: {
      "for": "input"
    }
  }, [_vm._v(_vm._s(!_vm.up ? '新增' : '編輯') + "商品")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.switchType),
      expression: "switchType"
    }],
    attrs: {
      "type": "radio",
      "id": "choose",
      "name": "type",
      "value": "choose"
    },
    domProps: {
      "checked": _vm._q(_vm.switchType, "choose")
    },
    on: {
      "change": function($event) {
        _vm.switchType = "choose"
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.switchType),
      expression: "switchType"
    }],
    attrs: {
      "type": "radio",
      "id": "input",
      "name": "type",
      "value": "input"
    },
    domProps: {
      "checked": _vm._q(_vm.switchType, "input")
    },
    on: {
      "change": function($event) {
        _vm.switchType = "input"
      }
    }
  })]), _vm._v(" "), (_vm.up) ? _c('div', {
    staticClass: "pull-right m-b-10",
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "right": "0"
    }
  }, [_vm._m(1)]) : _vm._e()]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group",
    staticStyle: {
      "max-width": "600px"
    }
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("商品名稱\n                "), (_vm.$route.name === 'crCategoryImg') ? _c('span', [_vm._v(" (分類)")]) : _vm._e()]), _vm._v(" "), (_vm.switchType === 'input') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.input.item.name),
      expression: "product.input.item.name"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "40px"
    },
    attrs: {
      "type": "text",
      "maxlength": "32"
    },
    domProps: {
      "value": (_vm.product.input.item.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product.input.item, "name", $event.target.value)
      }
    }
  }) : _c('multiselect', {
    attrs: {
      "options": _vm.optionsList,
      "searchable": true,
      "allow-empty": true,
      "close-on-select": true,
      "placeholder": "請輸入商品名稱",
      "show-labels": true,
      "multiple": false,
      "label": "name",
      "track-by": "id"
    },
    on: {
      "input": function($event) {
        return _vm.checkVenderId()
      }
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('span', [_vm._v(_vm._s(props.option.name))]), _vm._v(" "), _c('span', [_vm._v("(" + _vm._s(props.option.id) + ")")])]
      }
    }]),
    model: {
      value: (_vm.product.choose.item),
      callback: function($$v) {
        _vm.$set(_vm.product.choose, "item", $$v)
      },
      expression: "product.choose.item"
    }
  })], 1), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group has-feedback",
    class: !_vm.up ? _vm.product[_vm.switchType].isItemCanCreate ? 'has-success' : 'has-error' : '',
    staticStyle: {
      "max-width": "600px"
    }
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("商品料號\n                "), (_vm.$route.name === 'crCategoryImg') ? _c('span', [_vm._v(" (分類)")]) : _vm._e()]), _vm._v(" "), (_vm.switchType === 'input') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.input.item.id),
      expression: "product.input.item.id"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "40px"
    },
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "32"
    },
    domProps: {
      "value": (_vm.product.input.item.id)
    },
    on: {
      "focusout": _vm.checkVenderId,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product.input.item, "id", $event.target.value)
      }
    }
  }) : _c('multiselect', {
    attrs: {
      "options": _vm.optionsList,
      "searchable": true,
      "allow-empty": true,
      "close-on-select": true,
      "placeholder": "請輸入商品料號",
      "show-labels": true,
      "multiple": false,
      "label": "id",
      "track-by": "id"
    },
    on: {
      "input": function($event) {
        return _vm.checkVenderId()
      }
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('span', [_vm._v(_vm._s(props.option.name))]), _vm._v(" "), _c('span', [_vm._v("(" + _vm._s(props.option.id) + ")")])]
      }
    }]),
    model: {
      value: (_vm.product.choose.item),
      callback: function($$v) {
        _vm.$set(_vm.product.choose, "item", $$v)
      },
      expression: "product.choose.item"
    }
  }), _vm._v(" "), (!_vm.up) ? _c('span', {
    staticClass: "form-control-feedback",
    class: _vm.product[_vm.switchType].isItemCanCreate ? 'fa fa-check' : 'fa fa-times',
    staticStyle: {
      "line-height": "40px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.up) ? _c('span', {
    staticClass: "sr-only",
    attrs: {
      "id": "inputIconStatus"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("小圖 "), _c('br'), _vm._v(" "), (_vm.$route.name !== 'crCategoryImg') ? _c('span', [_vm._v("(80x60)")]) : _c('span', [_vm._v("(800x210)")])]), _vm._v(" "), (_vm.up) ? _c('img-update', {
    attrs: {
      "index": 99,
      "type": 1,
      "imgSrc": _vm.smImgSrc
    }
  }) : _c('img-up-drop', {
    attrs: {
      "id": "sm-image",
      "type": 1,
      "amount": 1,
      "imgList": _vm.imgList
    }
  })], 1), _vm._v(" "), _c('br')]), _vm._v(" "), (!_vm.up && _vm.$route.name !== 'crCategoryImg') ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('img-up-drop', {
    attrs: {
      "id": "lg-image",
      "type": 2,
      "amount": 5,
      "imgList": _vm.imgList
    }
  })], 1), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.up) ? _c('div', [_c('div', {
    staticClass: "input-group",
    staticStyle: {
      "max-width": "400px"
    }
  }, [_vm._m(3), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.enableOption,
      "label": "label",
      "searchable": false,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "啟用",
      "show-labels": false,
      "preselect-first": true
    },
    model: {
      value: (_vm.is_enabled),
      callback: function($$v) {
        _vm.is_enabled = $$v
      },
      expression: "is_enabled"
    }
  })], 1), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.elementList.length && this.tab !== 10) ? _c('div', {
    staticClass: "row form-inline"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticClass: "th-thin",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("大圖 (800x600)")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("排序")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("描述")]), _vm._v(" "), (_vm.up) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("刪除")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.elementList), function(element, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [(_vm.up) ? _c('img-update', {
      attrs: {
        "index": index,
        "type": 2,
        "imgSrc": element.img_url,
        "checkLoading": _vm.checkLoading
      }
    }) : _c('img', {
      staticClass: "h-auto img-responsive inline-block",
      attrs: {
        "src": element.img_url,
        "id": 'img-load' + index + '-' + _vm.type
      }
    })], 1), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "input-group has-feedback",
      class: {
        'has-error': element.isloading && element.sort === ''
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (element.sort),
        expression: "element.sort"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": "數字",
        "aria-describedby": "inputError"
      },
      domProps: {
        "value": (element.sort)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(element, "sort", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "form-control-feedback",
      class: {
        'fa fa-times': element.isloading && element.sort === ''
      },
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "sr-only",
      attrs: {
        "id": "inputError"
      }
    })])]), _vm._v(" "), _c('td', [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (element.description),
        expression: "element.description"
      }],
      staticClass: "form-control",
      staticStyle: {
        "max-width": "250px",
        "width": "100%"
      },
      attrs: {
        "placeholder": "描述"
      },
      domProps: {
        "value": (element.description)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(element, "description", $event.target.value)
        }
      }
    })]), _vm._v(" "), (_vm.up) ? _c('td', [(element.img_type) ? _c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#delModal"
      },
      on: {
        "click": function($event) {
          return _vm.clickCurrent(element.id, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e()]) : _vm._e()])
  }), 0)])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-fail text-black",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("\n            返回\n          ")]), _vm._v(" "), (!_vm.up) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkImg()
      }
    }
  }, [_vm._v("\n            新增\n          ")]) : _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkImg()
      }
    }
  }, [_vm._v("\n            更新\n          ")])])])])]), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.delSmImgOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.delOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h5', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" 相同料號的商品會一併新增、修改")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-danger inline-block",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#delSmModal"
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("大圖 "), _c('br'), _vm._v(" (800x600)\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("啟用\n              ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02e0c062"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Menu/CrImgSetting.vue
// module id = 2297
// module chunks = 1